import DataSource from "devextreme/data/data_source";
import { client } from "shared/helpers/client";
import { useAuthContext } from "shared/context/auth-context";
import React, { useCallback, useEffect } from "react";
import { useMutation, useQuery } from "react-query";
import { useForm } from "react-hook-form";
import * as yup from "yup";
import { yupResolver } from "@hookform/resolvers/yup";
import { useTranslation } from "react-i18next";

export enum GrantedUserStatus {
  Current = 100,
  Active = 105,
  Inactive = 106,
  Invited= 3003
}


export function useBookingUsers() {
  const {t} = useTranslation();
  const myUserSource = React.useMemo(() => new DataSource({
    key:"id",
    load(options) {
      return client<any>("/OwnerBooking/GetAllBookingUsers", {
        params: {
          skipCount: options.skip,
          maxResultCount: options.take,
        },
      }).then((r) => r.response);
    },
    update(id, updates) {
      return client<any>("/OwnerBooking/ChangeBookingUserPassword",{data: {userId:id,...updates} })
  },
  }),[]);


  const deleteUserServer = useMutation(userId => client('/ManageEmployee/DeleteEmployee',{params:{employeeId:userId}}));
  return {
    
    myUserSource,
    deleteUserServer
  }

}
